import { useCreation, useMemoizedFn } from "ahooks"
import Echart from "../BarCharts"
import type { FC } from "react"
import type { EChartsOption } from "echarts"

type IGraphProps = {
  list: { id: string; value: number; name: string }[]
  onClick?: (item: any) => void
}
const color = [
  "#1F73E1",
  "#00EDFA",
  "#C77EE4",
  "#F96779",
  "#FFC400",
  "#00CDAB",
  "#F58E4A",
  "#FDBFB9",
  "#5725E6",
  "#91c7ae",
]
const TreeMap: FC<IGraphProps> = ({ list = [], onClick }) => {
  const option = useCreation<EChartsOption>(() => {
    return {
      legend: { show: false },
      tooltip: {
        trigger: "item",
        formatter: function (params: any) {
          const { name, value } = params.data
          return `${name}: ${value}%`
        },
      },
      color: color,
      series: [
        {
          type: "treemap",
          width: "100%",
          height: "90%",
          breadcrumb: { show: false },
          roam: false,
          nodeClick: false,
          data: list.map((el: any) => {
            return {
              ...el,
              name: el.name,
              value: el.value,
            }
          }),
          label: {
            show: true,
            fontSize: 14,
          },
        },
      ],
    } as EChartsOption
  }, [list])

  const click = useMemoizedFn((params: any) => {
    onClick && onClick(params.data)
  })

  const events = useCreation(() => {
    return {
      click,
    }
  }, [click])

  return (
    <div className="ct-tree-map" style={{ height: "100%" }}>
      <Echart option={option} onEvents={events} />
    </div>
  )
}

export default TreeMap
